// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Select
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { SearchBar } from "components/Navbars/SearchBar/SearchBar";
import UsersTableRow from "components/Tables/UsersTableRow";
import React, { useCallback, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { GET_USERS } from "store/users";

const STATUS = [
  {
    value: 'Pending Approval',
    label: 'รออนุมัติ'
  },
  {
    value: 'Active',
    label: 'เปิดใช้งาน'
  },
  {
    value: 'Inactive',
    label: 'ปิดใช้งาน'
  }
];

const Authors = ({ title, captions, data, meta, listCourse }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const dispatch = useDispatch();
  const [selectedStatus, setSelectedStatus] = useState('Active'); // Default: Active

  const fetchData = useCallback((searchInput) => {
    dispatch(GET_USERS(`?search=${searchInput}`))
  }, [dispatch]);

  const handleStatusChange = useCallback((e) => {
    setSelectedStatus(e.target.value);
  }, []);

  // Filter data ฝั่ง frontend ตามสถานะที่เลือก
  const filteredData = useMemo(() => {
    if (!selectedStatus) return data;
    return data.filter(row => row.status === selectedStatus);
  }, [data, selectedStatus]);

  return (
    <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
      <CardHeader>
        <Flex justify='space-between' align='center' minHeight='60px' w='100%' gap={4}>
          <Text fontSize='lg' color={textColor} fontWeight='bold'>
            {title}
          </Text>
          <Flex gap={3} align='center'>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              width='200px'
              bg={useColorModeValue('white', 'gray.700')}
            >
              {STATUS.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </Select>
            <SearchBar fetchData={fetchData} />
          </Flex>
        </Flex>
      </CardHeader>
      <CardBody>
        <Table variant='simple' color={textColor}>
          <Thead>
            <Tr my='.8rem' pl='0px' color='gray.400'>
              {captions.map((caption, idx) => {
                return (
                  <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                    {caption}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((row) => {
              return (
                <UsersTableRow
                  key={row.id}
                  id={row.id}
                  name={`${row.firstname || ''} ${row.lastname || ''}`}
                  logo={row.logo}
                  username={row.username}
                  classroom={row.class}
                  school={row.school}
                  status={row.status}
                  print={row.print_status}
                  date={row.created_timestamp}
                />
              );
            })}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default Authors;